"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var queryBag = new URLSearchParams(window.location.search);
exports.queryBag = queryBag;
var queryList = {};
exports.queryList = queryList;
queryBag.forEach(function (v, k) {
    queryList[k] = v;
});
